import { useState } from "react";
import { motion } from "framer-motion";
import { Send, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FAMILY_IMG =
  "https://images.unsplash.com/photo-1787672358208-94075d85ab7d?fm=jpg&q=80&w=1200&auto=format&fit=crop";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const res = await fetch(`${API}/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="newsletter" className="py-24 lg:py-32 px-6 lg:px-12" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto bg-sand rounded-xl border border-border overflow-hidden">
        <div className="grid lg:grid-cols-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="p-10 lg:p-16"
          >
            <p className="font-sub text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-terra mb-4">La newsletter</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.1] tracking-tight mb-6">
              Recevez chaque nouveau <em className="italic text-terra">guide</em> et chaque nouvelle vidéo
            </h2>
            <p className="text-base leading-relaxed text-ink/70 mb-10 max-w-md">
              Un email par nouveau contenu, rien de plus. Pas de spam, désinscription en un clic.
            </p>
            {status === "success" ? (
              <div className="flex items-center gap-3 text-olive" data-testid="newsletter-success">
                <CheckCircle2 className="w-6 h-6" />
                <p className="font-sub font-bold">Merci ! Vous êtes bien inscrit·e.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.fr"
                  data-testid="newsletter-email-input"
                  className="flex-1 bg-white border border-border rounded-full px-6 py-3.5 text-sm outline-none focus:border-terra transition-colors duration-200"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  data-testid="newsletter-submit-button"
                  className="inline-flex items-center justify-center gap-2 bg-terra text-white font-sub text-sm font-medium px-7 py-3.5 rounded-full hover:bg-terra-dark hover:-translate-y-0.5 transition-[background-color,transform] duration-200 disabled:opacity-60"
                >
                  {status === "loading" ? "Inscription..." : "S'inscrire"}
                  <Send className="w-4 h-4" />
                </button>
              </form>
            )}
            {status === "error" && (
              <p className="text-sm text-terra mt-3" data-testid="newsletter-error">
                Une erreur est survenue. Réessayez dans un instant.
              </p>
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="hidden lg:block"
          >
            <img src={FAMILY_IMG} alt="Maison en cours de construction" className="w-full h-full object-cover" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
